module.exports = __webpack_public_path__ + "img/x8.c435159a.jpg";